import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { miawChatCheckLocale } from '../../utils/index';
import { get } from 'lodash';

const SalesforceEmbeddedChat = ({ memberInfo, messageContent}) => {
  const [showButton, setShowButton] = useState(false);
  const buttonIntervalRef = useRef(null);
  const miawOrgId = window.weeksWebCloudConfig?.MIAW_ORG_ID;
  const miawScriptUrl = window.weeksWebCloudConfig?.MIAW_SCRIPT_URL;
  const miawBootstrapUrl = window.weeksWebCloudConfig?.MIAW_BOOTSTRAP_URL;
  const miawScrt2Url = window.weeksWebCloudConfig?.MIAW_SCRT2_URL;
  const locale = memberInfo.locale?.toLowerCase();
  const bootStrapLocale = get(memberInfo, 'locale', 'en_US');
  const bootStrapLanguage = bootStrapLocale.slice(0, 2);
  let bootstrapLanguage = memberInfo.language?.code?.toLowerCase();
  let region = '';
  let deploymentId = '';
  let dynamicMiawScriptUrl = '';
  let dynamicMiawBootstrapUrl = '';
  
  const regionMap = {
    BR: ['pt_br'],
    LA: [
      'es_mx', 'es_ar', 'es_bz', 'es_bo', 'es_cl', 'es_co', 'es_cr', 'es_ec', 'es_sv',
      'es_gt', 'es_hn', 'es_ni', 'es_pa', 'es_py', 'es_pe', 'es_uy', 'es_ve'
    ],
    IN: ['en_in'],
    AP: ['en_au', 'en_sg', 'ja_jp', 'zh_cn'],
    EU: ['da_dk', 'de_de', 'es_es', 'fi_fi', 'fr_fr', 'it_it', 'ru_ru', 'sv_se', 'el_gr', 'pt_pt', 'nl_be', 'hu_hu', 'tr_tr'],
    UK: ['en_gb']
  };
  const languageMap = {
    pt_br: 'pt_BR',
    nl_be: 'nl_BE',
    zh_cn: 'zh_CN',
    pt_pt: 'pt_PT',
  };
  region = Object.keys(regionMap).find(key => regionMap[key].includes(locale)) || '';
  bootstrapLanguage = languageMap[locale] ?? bootstrapLanguage;
  const miawChatRegion = window.weeksWebCloudConfig?.MIAW_CHAT_REGION;
  deploymentId = miawChatRegion?.[region] || '';
  const miawDeploymentNameObj = window.weeksWebCloudConfig?.MIAW_DEPLOYMENT_NAME;
  const deploymentName = miawDeploymentNameObj?.[region] || '';
  dynamicMiawScriptUrl = miawScriptUrl?.replace('{DEPLOYMENTID}', deploymentId);
  dynamicMiawBootstrapUrl = miawBootstrapUrl?.replace('{DEPLOYMENTID}', deploymentId);
  useEffect(() => {
    const initEmbeddedMessaging = () => {
      try {
        window.embeddedservice_bootstrap.settings.language = bootstrapLanguage;
        window.addEventListener('onEmbeddedMessagingReady', () => {
          window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
            SubscriberId: memberInfo.subscriberId,
            LeadId: memberInfo.leadId,
            applicationType: memberInfo.applicationType,
            FirstName: memberInfo.firstName,
            LastName: memberInfo.lastName,
            IsMember: 'true',
            ReferringSite: window.location.href,
            Locale: memberInfo.locale,
            Browser: navigator.userAgent,
            Language: bootStrapLanguage,
          });
        });

        window.embeddedservice_bootstrap.init(
          miawOrgId,
          deploymentName,
          dynamicMiawScriptUrl,
          {
            scrt2URL: miawScrt2Url,
          }
        );
      } catch (err) {
        console.error('Error loading Embedded Messaging:', err);
      }
    };

    const script = document.createElement('script');
    script.src = dynamicMiawBootstrapUrl;
    script.async = true;
    script.onload = initEmbeddedMessaging;
    document.body.appendChild(script);
    buttonIntervalRef.current = setInterval(() => {
      setShowButton(true);

      setTimeout(() => {
        setShowButton(false);
      }, 30000); 
    }, 45000);

    return () => {
      clearInterval(buttonIntervalRef.current);
    };
  }, [memberInfo]);

  return showButton ? (
    <>
      {/* <button
        id="launchChatButtonNeedHelp"
        type="button"
        onClick={launchChat}
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '88px',
          padding: '10px 20px',
          backgroundColor: '#226486',
          color: '#ffffff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        {getTranslatedMessage(messageContent, 'RCIChat_Help', 1, 'Need Help?')}
      </button> */}
    </>
  ) : null;
};

SalesforceEmbeddedChat.propTypes = {
  memberInfo: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    memberId: PropTypes.string,
    phones: PropTypes.arrayOf(
      PropTypes.shape({
        number: PropTypes.string,
      }),
    ),
    emails: PropTypes.arrayOf(
      PropTypes.shape({
        address: PropTypes.string,
      }),
    ),
  }).isRequired,
  messageContent: PropTypes.instanceOf(Object),
};

SalesforceEmbeddedChat.defaultProps = {
  messageContent: {},
};

const ChatComponent = (props) => {
  const newChat = (window.weeksWebCloudConfig.MIAW_CHAT) && miawChatCheckLocale(props?.memberInfo?.locale);

  return newChat
    ? <SalesforceEmbeddedChat {...props} />
    : null;
};

export default ChatComponent;